<template lang="html">
  <div class="card">
    <ul class="tabs__header nav nav-tabs">
      <li
        class="nav-item"
        v-for="(tab, index) in tabsComentario"
        :key="tab.title"
        @click="selectTab(index)"
        :class="{ tabs__selected: index == selectedIndex }"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedIndex: 0, // el índice de la pestaña seleccionada
      tabsComentario: [], // todas las pestañas
    };
  },
  created() {
    this.tabsComentario = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;

      // recorre todas las pestañas
      this.tabsComentario.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    },
  },
};
</script>

<style lang="css">
ul.tabs__header > li {
  padding: 15px 30px;
  border-radius: 10px;
  margin: 0;
  display: inline-block;
  margin-right: 5px;
  cursor: pointer;
  background-color: white;
  transition: 0.5s;
}

.tabs__header li:hover {
  background-color: var(--color-estructura-c);
  transition: 0.4s;
  color: white;
}
</style>
